const _temp0 = require("../../../@react-spectrum/accordion/chromatic/Accordion.chromatic.tsx");


const _temp1 = require("../../../@react-spectrum/actionbar/chromatic/ActionBar.chromatic.tsx");


const _temp2 = require("../../../@react-spectrum/actiongroup/chromatic/ActionGroup.chromatic.tsx");


const _temp3 = require("../../../@react-spectrum/autocomplete/chromatic/SearchAutocomplete.chromatic.tsx");

const _temp4 = require("../../../@react-spectrum/autocomplete/chromatic/SearchAutocompleteRTL.chromatic.tsx");


const _temp5 = require("../../../@react-spectrum/avatar/chromatic/Avatar.chromatic.tsx");


const _temp6 = require("../../../@react-spectrum/button/chromatic/ActionButton.chromatic.tsx");

const _temp7 = require("../../../@react-spectrum/button/chromatic/ActionButtonLanguages.chromatic.tsx");

const _temp8 = require("../../../@react-spectrum/button/chromatic/Button.chromatic.tsx");

const _temp9 = require("../../../@react-spectrum/button/chromatic/LogicButton.chromatic.tsx");

const _temp10 = require("../../../@react-spectrum/button/chromatic/ToggleButton.chromatic.tsx");


const _temp11 = require("../../../@react-spectrum/badge/chromatic/Badge.chromatic.tsx");


const _temp12 = require("../../../@react-spectrum/breadcrumbs/chromatic/Breadcrumbs.chromatic.tsx");


const _temp13 = require("../../../@react-spectrum/buttongroup/chromatic/ButtonGroup.chromatic.tsx");


const _temp14 = require("../../../@react-spectrum/calendar/chromatic/Calendar.chromatic.tsx");

const _temp15 = require("../../../@react-spectrum/calendar/chromatic/CalendarCell.chromatic.tsx");

const _temp16 = require("../../../@react-spectrum/calendar/chromatic/RangeCalendar.chromatic.tsx");


const _temp17 = require("../../../@react-spectrum/card/chromatic/Card.chromatic.tsx");

const _temp18 = require("../../../@react-spectrum/card/chromatic/CardView.chromatic.tsx");

const _temp19 = require("../../../@react-spectrum/card/chromatic/HorizontalCard.chromatic.tsx");

const _temp20 = require("../../../@react-spectrum/card/chromatic/QuietCard.chromatic.tsx");


const _temp21 = require("../../../@react-spectrum/color/chromatic/ColorArea.chromatic.tsx");

const _temp22 = require("../../../@react-spectrum/color/chromatic/ColorField.chromatic.tsx");

const _temp23 = require("../../../@react-spectrum/color/chromatic/ColorFieldExpress.chromatic.tsx");

const _temp24 = require("../../../@react-spectrum/color/chromatic/ColorSlider.chromatic.tsx");


const _temp25 = require("../../../@react-spectrum/checkbox/chromatic/Checkbox.chromatic.tsx");

const _temp26 = require("../../../@react-spectrum/checkbox/chromatic/CheckboxGroup.chromatic.tsx");


const _temp27 = require("../../../@react-spectrum/combobox/chromatic/ComboBox.chromatic.tsx");

const _temp28 = require("../../../@react-spectrum/combobox/chromatic/ComboBoxRTL.chromatic.tsx");


const _temp29 = require("../../../@react-spectrum/dialog/chromatic/AlertDialog.chromatic.tsx");

const _temp30 = require("../../../@react-spectrum/dialog/chromatic/Dialog.chromatic.tsx");

const _temp31 = require("../../../@react-spectrum/dialog/chromatic/DialogExpress.chromatic.tsx");


const _temp32 = require("../../../@react-spectrum/datepicker/chromatic/DateField.chromatic.tsx");

const _temp33 = require("../../../@react-spectrum/datepicker/chromatic/DatePicker.chromatic.tsx");

const _temp34 = require("../../../@react-spectrum/datepicker/chromatic/DateRangePicker.chromatic.tsx");

const _temp35 = require("../../../@react-spectrum/datepicker/chromatic/TimeField.chromatic.tsx");


const _temp36 = require("../../../@react-spectrum/divider/chromatic/Divider.chromatic.tsx");


const _temp37 = require("../../../@react-spectrum/form/chromatic/Form.chromatic.tsx");

const _temp38 = require("../../../@react-spectrum/form/chromatic/FormLongLabel.chromatic.tsx");


const _temp39 = require("../../../@react-spectrum/illustratedmessage/chromatic/IllustratedMessage.Languages.chromatic.tsx");

const _temp40 = require("../../../@react-spectrum/illustratedmessage/chromatic/IllustratedMessage.chromatic.tsx");


const _temp41 = require("../../../@react-spectrum/label/chromatic/HelpText.chromatic.tsx");

const _temp42 = require("../../../@react-spectrum/label/chromatic/Label.chromatic.tsx");


const _temp43 = require("../../../@react-spectrum/labeledvalue/chromatic/LabeledValue.chromatic.tsx");


const _temp44 = require("../../../@react-spectrum/layout/chromatic/Flex.chromatic.tsx");

const _temp45 = require("../../../@react-spectrum/layout/chromatic/Grid.chromatic.tsx");


const _temp46 = require("../../../@react-spectrum/link/chromatic/Link.chromatic.tsx");


const _temp47 = require("../../../@react-spectrum/list/chromatic/ListView.chromatic.tsx");

const _temp48 = require("../../../@react-spectrum/list/chromatic/ListViewRTL.chromatic.tsx");


const _temp49 = require("../../../@react-spectrum/listbox/chromatic/ListBox.chromatic.tsx");


const _temp50 = require("../../../@react-spectrum/meter/chromatic/Meter.chromatic.tsx");


const _temp51 = require("../../../@react-spectrum/menu/chromatic/MenuTrigger.chromatic.tsx");

const _temp52 = require("../../../@react-spectrum/menu/chromatic/MenuTriggerExpress.chromatic.tsx");

const _temp53 = require("../../../@react-spectrum/menu/chromatic/MenuTriggerRTL.chromatic.tsx");


const _temp54 = require("../../../@react-spectrum/numberfield/chromatic/NumberField.chromatic.tsx");


const _temp55 = require("../../../@react-spectrum/picker/chromatic/Picker.Languages.chromatic.tsx");

const _temp56 = require("../../../@react-spectrum/picker/chromatic/Picker.chromatic.tsx");


const _temp57 = require("../../../@react-spectrum/progress/chromatic/ProgressBar.chromatic.tsx");

const _temp58 = require("../../../@react-spectrum/progress/chromatic/ProgressCircle.chromatic.tsx");


const _temp59 = require("../../../@react-spectrum/provider/chromatic/Provider.chromatic.tsx");


const _temp60 = require("../../../@react-spectrum/radio/chromatic/Radio.chromatic.tsx");


const _temp61 = require("../../../@react-spectrum/searchfield/chromatic/SearchField.chromatic.tsx");


const _temp62 = require("../../../@react-spectrum/searchwithin/chromatic/SearchWithin.chromatic.tsx");


const _temp63 = require("../../../@react-spectrum/slider/chromatic/RangeSlider.chromatic.tsx");

const _temp64 = require("../../../@react-spectrum/slider/chromatic/Slider.chromatic.tsx");


const _temp65 = require("../../../@react-spectrum/statuslight/chromatic/StatusLight.chromatic.tsx");

const _temp66 = require("../../../@react-spectrum/statuslight/chromatic/StatusLightLanguages.chromatic.tsx");


const _temp67 = require("../../../@react-spectrum/switch/chromatic/Switch.chromatic.tsx");


const _temp68 = require("../../../@react-spectrum/table/chromatic/TableView.chromatic.tsx");

const _temp69 = require("../../../@react-spectrum/table/chromatic/TableViewRTL.chromatic.tsx");


const _temp70 = require("../../../@react-spectrum/tabs/chromatic/Tabs.chromatic.tsx");


const _temp71 = require("../../../@react-spectrum/tag/chromatic/TagGroup.chromatic.tsx");


const _temp72 = require("../../../@react-spectrum/textfield/chromatic/TextArea.chromatic.tsx");

const _temp73 = require("../../../@react-spectrum/textfield/chromatic/TextAreaLanguages.chromatic.tsx");

const _temp74 = require("../../../@react-spectrum/textfield/chromatic/Textfield.chromatic.tsx");

const _temp75 = require("../../../@react-spectrum/textfield/chromatic/TextfieldLanguages.chromatic.tsx");


const _temp76 = require("../../../@react-spectrum/toast/chromatic/Toast.chromatic.tsx");


const _temp77 = require("../../../@react-spectrum/tooltip/chromatic/Tooltip.chromatic.tsx");

const _temp78 = require("../../../@react-spectrum/tooltip/chromatic/TooltipTrigger.chromatic.tsx");

const _temp79 = require("../../../@react-spectrum/tooltip/chromatic/TooltipTriggerExpress.chromatic.tsx");

const _temp80 = require("../../../@react-spectrum/tooltip/chromatic/TooltipTriggerRTL.chromatic.tsx");


const _temp81 = require("../../../@react-spectrum/view/chromatic/View.chromatic.tsx");


const _temp82 = require("../../../@react-spectrum/well/chromatic/Well.chromatic.tsx");



const _temp83 = require("../../../@spectrum-icons/express/chromatic/IconsExpress.chromatic.tsx");


const _temp84 = require("../../../@spectrum-icons/workflow/chromatic/Workflow.chromatic.tsx");



module.exports = {
  "@react-spectrum":   {
    "accordion":     {
      "Accordion":       {
        "tsx": _temp0
      }
    },
    "actionbar":     {
      "ActionBar":       {
        "tsx": _temp1
      }
    },
    "actiongroup":     {
      "ActionGroup":       {
        "tsx": _temp2
      }
    },
    "autocomplete":     {
      "SearchAutocomplete":       {
        "tsx": _temp3
      },
      "SearchAutocompleteRTL":       {
        "tsx": _temp4
      }
    },
    "avatar":     {
      "Avatar":       {
        "tsx": _temp5
      }
    },
    "button":     {
      "ActionButton":       {
        "tsx": _temp6
      },
      "ActionButtonLanguages":       {
        "tsx": _temp7
      },
      "Button":       {
        "tsx": _temp8
      },
      "LogicButton":       {
        "tsx": _temp9
      },
      "ToggleButton":       {
        "tsx": _temp10
      }
    },
    "badge":     {
      "Badge":       {
        "tsx": _temp11
      }
    },
    "breadcrumbs":     {
      "Breadcrumbs":       {
        "tsx": _temp12
      }
    },
    "buttongroup":     {
      "ButtonGroup":       {
        "tsx": _temp13
      }
    },
    "calendar":     {
      "Calendar":       {
        "tsx": _temp14
      },
      "CalendarCell":       {
        "tsx": _temp15
      },
      "RangeCalendar":       {
        "tsx": _temp16
      }
    },
    "card":     {
      "Card":       {
        "tsx": _temp17
      },
      "CardView":       {
        "tsx": _temp18
      },
      "HorizontalCard":       {
        "tsx": _temp19
      },
      "QuietCard":       {
        "tsx": _temp20
      }
    },
    "color":     {
      "ColorArea":       {
        "tsx": _temp21
      },
      "ColorField":       {
        "tsx": _temp22
      },
      "ColorFieldExpress":       {
        "tsx": _temp23
      },
      "ColorSlider":       {
        "tsx": _temp24
      }
    },
    "checkbox":     {
      "Checkbox":       {
        "tsx": _temp25
      },
      "CheckboxGroup":       {
        "tsx": _temp26
      }
    },
    "combobox":     {
      "ComboBox":       {
        "tsx": _temp27
      },
      "ComboBoxRTL":       {
        "tsx": _temp28
      }
    },
    "dialog":     {
      "AlertDialog":       {
        "tsx": _temp29
      },
      "Dialog":       {
        "tsx": _temp30
      },
      "DialogExpress":       {
        "tsx": _temp31
      }
    },
    "datepicker":     {
      "DateField":       {
        "tsx": _temp32
      },
      "DatePicker":       {
        "tsx": _temp33
      },
      "DateRangePicker":       {
        "tsx": _temp34
      },
      "TimeField":       {
        "tsx": _temp35
      }
    },
    "divider":     {
      "Divider":       {
        "tsx": _temp36
      }
    },
    "form":     {
      "Form":       {
        "tsx": _temp37
      },
      "FormLongLabel":       {
        "tsx": _temp38
      }
    },
    "illustratedmessage":     {
      "IllustratedMessage.Languages":       {
        "tsx": _temp39
      },
      "IllustratedMessage":       {
        "tsx": _temp40
      }
    },
    "label":     {
      "HelpText":       {
        "tsx": _temp41
      },
      "Label":       {
        "tsx": _temp42
      }
    },
    "labeledvalue":     {
      "LabeledValue":       {
        "tsx": _temp43
      }
    },
    "layout":     {
      "Flex":       {
        "tsx": _temp44
      },
      "Grid":       {
        "tsx": _temp45
      }
    },
    "link":     {
      "Link":       {
        "tsx": _temp46
      }
    },
    "list":     {
      "ListView":       {
        "tsx": _temp47
      },
      "ListViewRTL":       {
        "tsx": _temp48
      }
    },
    "listbox":     {
      "ListBox":       {
        "tsx": _temp49
      }
    },
    "meter":     {
      "Meter":       {
        "tsx": _temp50
      }
    },
    "menu":     {
      "MenuTrigger":       {
        "tsx": _temp51
      },
      "MenuTriggerExpress":       {
        "tsx": _temp52
      },
      "MenuTriggerRTL":       {
        "tsx": _temp53
      }
    },
    "numberfield":     {
      "NumberField":       {
        "tsx": _temp54
      }
    },
    "picker":     {
      "Picker.Languages":       {
        "tsx": _temp55
      },
      "Picker":       {
        "tsx": _temp56
      }
    },
    "progress":     {
      "ProgressBar":       {
        "tsx": _temp57
      },
      "ProgressCircle":       {
        "tsx": _temp58
      }
    },
    "provider":     {
      "Provider":       {
        "tsx": _temp59
      }
    },
    "radio":     {
      "Radio":       {
        "tsx": _temp60
      }
    },
    "searchfield":     {
      "SearchField":       {
        "tsx": _temp61
      }
    },
    "searchwithin":     {
      "SearchWithin":       {
        "tsx": _temp62
      }
    },
    "slider":     {
      "RangeSlider":       {
        "tsx": _temp63
      },
      "Slider":       {
        "tsx": _temp64
      }
    },
    "statuslight":     {
      "StatusLight":       {
        "tsx": _temp65
      },
      "StatusLightLanguages":       {
        "tsx": _temp66
      }
    },
    "switch":     {
      "Switch":       {
        "tsx": _temp67
      }
    },
    "table":     {
      "TableView":       {
        "tsx": _temp68
      },
      "TableViewRTL":       {
        "tsx": _temp69
      }
    },
    "tabs":     {
      "Tabs":       {
        "tsx": _temp70
      }
    },
    "tag":     {
      "TagGroup":       {
        "tsx": _temp71
      }
    },
    "textfield":     {
      "TextArea":       {
        "tsx": _temp72
      },
      "TextAreaLanguages":       {
        "tsx": _temp73
      },
      "Textfield":       {
        "tsx": _temp74
      },
      "TextfieldLanguages":       {
        "tsx": _temp75
      }
    },
    "toast":     {
      "Toast":       {
        "tsx": _temp76
      }
    },
    "tooltip":     {
      "Tooltip":       {
        "tsx": _temp77
      },
      "TooltipTrigger":       {
        "tsx": _temp78
      },
      "TooltipTriggerExpress":       {
        "tsx": _temp79
      },
      "TooltipTriggerRTL":       {
        "tsx": _temp80
      }
    },
    "view":     {
      "View":       {
        "tsx": _temp81
      }
    },
    "well":     {
      "Well":       {
        "tsx": _temp82
      }
    }
  },
  "@spectrum-icons":   {
    "express":     {
      "IconsExpress":       {
        "tsx": _temp83
      }
    },
    "workflow":     {
      "Workflow":       {
        "tsx": _temp84
      }
    }
  }
}